// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5128) return "static/chunks/5128-22264dd091d14a87.js";
	if (chunkId === 756) return "static/chunks/756-5b5245a0a57ffe1e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3250":"b27593273723d69a","5631":"22325f5384c4f75f","8012":"735e51090c1c378f"}[chunkId] + ".js";
};